import { createSelector } from 'reselect';
import { KEY, CustomerState } from './types';
import { GlobalState } from 'store/types';

const getCustomerState = (state: GlobalState) => state[KEY] as CustomerState;

const selectLoading = createSelector(getCustomerState, (customer) => customer.loading);

const selectError = createSelector(getCustomerState, (customer) => customer.error);

const selectCustomer = createSelector(getCustomerState, (customer) => customer.customer);

const selectLookupData = createSelector(getCustomerState, (customer) => customer.lookupData);

const selectSurvey = createSelector(getCustomerState, (customer) => customer.survey);

const selectLocations = createSelector(getCustomerState, (customer) => customer.locations);

const selectIsLocal = createSelector(getCustomerState, (customer) => customer.isLocal);

const selectPhoneCountry = createSelector(getCustomerState, (customer) => customer.phoneCountry);

const selectSavedEmail = createSelector(
  getCustomerState,
  (customer) =>
    (customer.customer && customer.customer.email) ||
    (customer.lookupData && customer.lookupData.email) ||
    (customer.survey && customer.survey.email)
);

export const selectors = {
  selectLoading,
  selectError,
  selectCustomer,
  selectLookupData,
  selectSurvey,
  selectLocations,
  selectIsLocal,
  selectPhoneCountry,
  selectSavedEmail
};
